// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Wd4To","content":"RecentSearches_content__1PSjf"};